import { render, staticRenderFns } from "./DesignPanelWrapper.vue?vue&type=template&id=0a2fc860&scoped=true&"
import script from "./DesignPanelWrapper.vue?vue&type=script&lang=js&"
export * from "./DesignPanelWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DesignPanelWrapper.vue?vue&type=style&index=0&id=0a2fc860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2fc860",
  null
  
)

export default component.exports